import Axios from "axios";
import {StationData} from "../entities/station-data";
import {GraphData} from "entities/graph-data";
import {GraphDataType} from "entities/graph-data-type";

export const getCurrentData = () => Axios.get<StationData[]>("current-data.json");
export const getGraphData = (stationId: number, graphDataType: GraphDataType, from: number, to: number) => Axios.get<GraphData[]>(
    `${stationId}/${graphDataType.key}.json`, { params: { from, to } }
);
